export default __webpack_public_path__ + "static/media/abc-logo-to-print.1e826e31.svg";